// Recevies a string and returns a slugified version of it
export const slugify = (text: string): string => {
  return text.toLowerCase().trim().replace(/ /g, '-')
}
